import $ from 'jquery';
import { isMobilePortrait } from '../util/sizes';
import { withSiteUrl } from '../api/url';

export default class Productpage {
  public static init(): void {
    Productpage.loadPreviousGiftBox();
  }

  private static loadPreviousGiftBox(): void {
    const previousGiftViewer = $('#previous-cadeau-viewer');
    let giftViewerUrl = withSiteUrl('/product-page/recently-viewed');
    if (isMobilePortrait()) {
      giftViewerUrl += '?mobileLimit=true';
    }
    if (previousGiftViewer.length) {
      $.ajax({
        dataType: 'html',
        method: 'GET',
        success(data) {
          if (data !== '') {
            $(data).insertBefore(previousGiftViewer);
          }
        },
        url: giftViewerUrl,
      }).catch(() => null);
    }
  }
}
